// src/components/Layout/Footer.jsx
import React from "react";
import Logo from "../assets/icons/logo-2.svg"; // ajustá la ruta

const Footer = () => {
  return (
    <footer className="w-full snap-end text-white">
      <div className="grid grid-cols-1 sm:grid-cols-[1fr_14px_1.4fr] w-full">
        {/* Izquierda: logo + pill */}
        <div className="bg-white text-[#0B0A0B] px-6 sm:px-8 py-6 sm:py-8 flex flex-col items-center justify-center gap-2">
        <img src={Logo} alt="RTAG" className="h-8 sm:h-8 w-auto" />
        <span className="inline-flex items-center px-4 py-2 rounded-full bg-[#3A3A3A] text-white/90 text-xs sm:text-sm font-bai italic">
            Servicios Industriales
        </span>
        </div>

        {/* Separador diagonal (desktop) */}
        <div
          className="hidden sm:block"
          style={{
            background:
              "repeating-linear-gradient(135deg, #ffffff 0 10px, transparent 10px 20px)",
            backgroundColor: "#2FA58C",
          }}
        />

        {/* Derecha: contacto */}
        <div className="bg-[#2FA58C] px-6 sm:px-10 py-6 sm:py-8">
          <div className="flex flex-col gap-2">
            <a href="tel:+5491144183407" className="font-inter text-sm sm:text-base hover:opacity-90">
              +54 9 11 44183407
            </a>
            <a
              href="mailto:serviciosindustriales@rtag.com.ar"
              className="font-inter text-sm sm:text-base hover:opacity-90 break-all"
            >
              serviciosindustriales@rtag.com.ar
            </a>
            <p className="font-inter text-sm sm:text-base">Río Tercero - Córdoba</p>
            <p className="font-inter text-sm sm:text-base">©2023 por RTAG</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;